module.exports = __webpack_public_path__ + "media/brands/HillcountryInnovationsLogo-aeb5990f.png";